import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
    selector: 'shared-address-info',
    standalone: true,
    imports: [NgSelectModule, FormsModule],
    template: `
        <address class="d-flex flex-column">
            @for (line of lines; track $index) {
                <span>{{ line }}</span>
            }
        </address>
    `,
})
export class AddressInfo implements OnChanges {

    @Input() address: any;

    lines: string[] = [];
    linesAttributes: any[] = [
        ['name1'],
        ['street', 'street_number', 'street_number_suffix'],
        ['postal_code', 'locality'],
        ['country_code'],
    ]

    ngOnChanges(changes: SimpleChanges) {
        this.lines = [];

        if (this.address) {
            for (let lineAttributes of this.linesAttributes) {
                let line: string[] = [];
                for (let attribute of lineAttributes) {
                    if (this.address[attribute] ?? null) {
                        line.push(this.address[attribute]);
                    }
                }

                if (line.length > 0) {
                    this.lines.push(line.join(' '));
                }
            }
        }
    }
}
